/* istanbul ignore next */
export const calculateTextWidth = (text, font) => {
  const canvas = calculateTextWidth.canvas || (calculateTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
};

export const getElementFont = element => {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return '';
  }

  const {
    'font-family': fontFamily,
    'font-size': fontSize,
    'font-style': fontStyle,
    'font-weight': fontWeight,
  } = window.getComputedStyle(element);

  return [fontStyle, fontWeight, fontSize, fontFamily].filter(Boolean).join(' ');
};

export default calculateTextWidth;
